import Swiper from 'swiper';
import {Pagination, Navigation} from 'swiper/modules';

export function handleSlider():void {
	new Swiper('#discover-slider', {
		modules: [Pagination, Navigation],
		pagination: {
			clickable: true,
			el: '.discover__slides .swiper-pagination',
		},
		navigation: {
			prevEl: '.discover__slides .swiper-button-prev',
			nextEl: '.discover__slides .swiper-button-next',
		},
		slidesPerView: 1.38,
		breakpoints: {
			1024: {
				slidesPerView: 3,
			},
		},
	})
}